import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import SideBarItem from '../SideBarItem/SideBarItem';
import arrow from '../../brand/generated/header/arrowUser.svg';
import { isInSection } from './menuSection';

const hasActiveChilds = (arr, pathname) => {
  for (let i = 0; i < arr.length; i++) {
    if (pathname === arr[i].path) {
      return true;
    }
    if (arr[i].children && hasActiveChilds(arr[i].children, pathname)) {
      return true;
    }
  }

  return false;
};
// ÐÐµÐ· ÑÑÐ¾Ð³Ð¾ ÐºÐ½Ð¾Ð¿ÐºÐ° ÑÐ¸ÑÑÐµÑÑÑ ÑÐµÑÐ¾Ð¹ ÐºÐ¾ÑÐ¾Ð±ÐºÐ¾Ð¹ Ð±ÑÐ°ÑÐ·ÐµÑÐ° Ð¸ Ð±ÑÐ¾ÑÐ°ÐµÑÑÑ Ð² Ð³Ð»Ð°Ð·Ð°: ÑÑÑÐµÐ»ÐºÐ° Ð´Ð¾Ð»Ð¶Ð½Ð° Ð±ÑÑÑ ÑÐ¸ÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ Ð¿ÑÐ½ÐºÑÐ°.
const ARROW_BUTTON_STYLE = {
  background: 'none',
  border: 'none',
  padding: '0 14px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  opacity: 0.6,
};

const Menu = ({ items, onLinkClick }) => {
  const location = useLocation();
  const [menuState, setMenuState] = useState(items.map(() => false));

  const toggleSubmenu = (index) => {
    setMenuState((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };

  return (
    <>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <NavLink
            to={item.path}
            end={item.path == '/' ? true : false}
            onClick={onLinkClick}
            data-tour={item.tour}
            style={({ isActive }) => ({
              display: 'flex',
              background:
                isActive || (location.pathname.split('/')[1] === 'client' && item.name === 'client')
                  ? 'rgba(255, 255, 255, 0.1)'
                  : '',
            })}
          >
            <div style={{ flex: 1 }}>
              <SideBarItem
                title={item.title}
                icon={item.icon}
                path={item.path}
                key={item.id}
                count_1={item.count}
                count_2={item.count_2}
              />
            </div>
            {item.children && (
              <button type="button" onClick={() => toggleSubmenu(index)} style={ARROW_BUTTON_STYLE}>
                <img
                  style={{
                    transform: `rotateZ(${menuState[index] ? 0 : '-90deg'})`,
                    transition: 'transform 0.15s',
                  }}
                  src={arrow}
                  alt={'Arrow'}
                />
              </button>
            )}
          </NavLink>
          <div style={{ marginLeft: 10 }}>
            {item.children &&
              (isInSection(location.pathname, item.path) ||
                menuState[index] ||
                hasActiveChilds(item.children, location.pathname)) && <Menu items={item.children} onLinkClick={onLinkClick} />}
          </div>
        </React.Fragment>
      ))}
    </>
  );
};

export default Menu;
